import React from 'react';
import * as translator from "../../../../utils/translator";
import { clientConfig } from '../../../../config';
import { OptionCard } from '../../../ContactUs/OptionCard';
import { getFaqUrl, getUrlPrefix, isWhatsAppAvailable, getIsReturningCustomer, openWhatsAppChat as openWA, openHubSpotChat } from '../../../ContactUs/contactUsUtils';
import { useHubSpotChat } from '../../../../customHooks/useHubSpotChat';
import { MainTracker } from '../../../../PixelTrackers/MainTracker';

const trackChatWithUsClick = (serviceType: string) => {
    MainTracker.track('custom', 'CMS Menu Chat With Us Click', { service_type: serviceType });
};

interface ContactUsViewProps {
    language: string;
    country: string;
}

export const ContactUsView: React.FC<ContactUsViewProps> = ({ language, country }) => {
    const isHubSpotAvailable = useHubSpotChat();
    const t = (key: string) => translator.translate(language, "contact", `SupportOptions/${key}`);

    const isGermany = country?.toUpperCase() === 'DE';
    const isRP = getIsReturningCustomer();
    const faqUrl = getFaqUrl(country, language);
    const contactFormUrl = `${clientConfig.FUNNEL_URL}/${getUrlPrefix(country, language)}/contact`;
    const waAvailable = isWhatsAppAvailable();
    const handleOpenWhatsApp = () => openWA(t('whatsapp_link_number'), t('whatsapp_prefilled_message'));

    const whatsappDesc = t('whatsapp_description');

    return (
        <div className="bg-white min-h-full">
            <div className="px-7 pt-7 pb-4">
                <h2 className="text-[24px] md:text-[28px] font-semibold font-header contact-page-title-highlight mb-3">
                    {t('title')}
                </h2>
                <p className="text-[14px] text-[#616975] font-header leading-[140%] m-0 font-normal">
                    {t('subtitle')} <span className="font-medium text-[#08080A]">{t('hours')}</span>{' '}
                    {language === 'de' && t('suffix')}
                </p>
            </div>

            <div className="flex flex-col gap-[14px] px-7 pb-5">
                {isRP ? (
                    <>
                        <OptionCard iconKey="chat" title={t('live_chat')} description={t('live_chat_description')} buttonText={t('start_live_chat')} onClick={() => { trackChatWithUsClick('Live chat'); openHubSpotChat(); }} isBlurred={!isHubSpotAvailable} unavailableText={t('live_chat_unavailable')} />
                        {isGermany && <OptionCard iconKey="whatsapp" title={t('whatsapp_chat')} description={whatsappDesc} buttonText={t('open_whatsapp')} onClick={() => { trackChatWithUsClick('WhatsApp'); handleOpenWhatsApp(); }} isBlurred={!waAvailable} unavailableText={t('live_chat_unavailable')} />}
                        <OptionCard iconKey="form" title={t('contact_form')} description={t('contact_form_description')} buttonText={t('submit_ticket')} onClick={() => { trackChatWithUsClick('Contact form'); window.location.href = contactFormUrl; }} />
                        <OptionCard iconKey="help" title={t('help_center')} description={t('help_center_description')} buttonText={t('go_to_faq')} onClick={() => { trackChatWithUsClick('Help center'); window.open(faqUrl, '_blank'); }} />
                    </>
                ) : (
                    <>
                        <OptionCard iconKey="form" title={t('contact_form')} description={t('contact_form_description')} buttonText={t('submit_ticket')} onClick={() => { trackChatWithUsClick('Contact form'); window.location.href = contactFormUrl; }} />
                        <OptionCard iconKey="help" title={t('help_center')} description={t('help_center_description')} buttonText={t('go_to_faq')} onClick={() => { trackChatWithUsClick('Help center'); window.open(faqUrl, '_blank'); }} />
                        <OptionCard iconKey="chat" title={t('live_chat')} description={t('live_chat_description')} buttonText={t('start_live_chat')} onClick={() => { trackChatWithUsClick('Live chat'); openHubSpotChat(); }} isBlurred={!isHubSpotAvailable} unavailableText={t('live_chat_unavailable')} />
                    </>
                )}
            </div>

            <div className="contact-us-footer-container">
                <p className="contact-us-footer-text">
                    <span className="contact-us-footer-label">{t('outside_support_hours')}</span><br/>
                    {t('outside_support_hours_message')}
                </p>
            </div>
        </div>
    );
};
